export const languagesQueryKeys = {
    languages: () => ['languages'] as const,
    languageDetails: (languageId: string) =>
        [...languagesQueryKeys.languages(), languageId, 'details'] as const,
    languageMessageContent: (languageId: string) =>
        [
            ...languagesQueryKeys.languages(),
            languageId,
            'message-content',
        ] as const,
    languageAttributes: () =>
        [...languagesQueryKeys.languages(), 'attributes'] as const,
    languageAudienceCount: (languageId: string) =>
        [
            ...languagesQueryKeys.languages(),
            languageId,
            'audience-count',
        ] as const,
    languageAttribute: ['language-attribute'] as const,
    localeCodes: () => ['locales'],
};
